export default __webpack_public_path__ + "static/media/epaule.f144f011.jpg";